import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LicenseService } from '../../components/services';
import { LicenseDto, LicenseInfo } from '../../types/interfaces';

export function normalizeLicense(dto: LicenseDto): LicenseInfo {
  const lockDateTime = dto.timeLimit;
  const maxUsers = dto.userLimit;
  const currentUsers = dto.userCount;
  const isExpired = new Date(lockDateTime).getTime() <= Date.now();

  return { raw: dto, lockDateTime, maxUsers, currentUsers, isExpired };
}

export interface LicenseState {
  info: LicenseInfo | null;
  isExpired: boolean;
  isLoading: boolean;
}

const initialState: LicenseState = {
  info: null,
  isExpired: false,
  isLoading: false
};

export const getLicenseAsync = createAsyncThunk('license/get', async () => {
  const resp = await LicenseService.getLicense();
  const dto = (resp.data ?? {}) as LicenseDto;
  return normalizeLicense(dto);
});

const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    setLicenseExpired: (state, action: PayloadAction<boolean>) => {
      state.isExpired = action.payload;
      if (action.payload) {
        state.info = null;
      }
    },
    setLicenseInfo: (state, action: PayloadAction<LicenseDto>) => {
      const info = normalizeLicense(action.payload);
      state.info = info;
      state.isExpired = info.isExpired;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLicenseAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getLicenseAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.info = action.payload;
      state.isExpired = action.payload.isExpired;
    });
    builder.addCase(getLicenseAsync.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const { setLicenseExpired, setLicenseInfo } = licenseSlice.actions;
export default licenseSlice.reducer;


